var symphony = symphony || {};

;
(function () {

	symphony.wordpressFeed = {
		localLoadTries: 0,
		waitingForResponse: false,
		localStories: {
			featuredDocs: [],
			activeDocs: []
		},
		wordpressStories: [],
		combinedActiveDocs: [],
		pageNumber: 0,
		pageSize: 12
	};

	symphony.getLocalStories = function () {

		if ($('#storiesIndex').length <= 0) {
			return;
		}

		if (!_.isNull(hiddenPages)) {

			if (_.indexOf(hiddenPages, 'pressreleases') !== -1) {
				if (useWpStories && hiddenPages.indexOf('pressreleases') > -1) {
					getWordpressDocs();
				} else if (canUseWordpressFeed && wordpressFeedUrl != '') {
					getCombinedStoriesList();
				} else {
					return;
				}
			} else if (canUseWordpressFeed && wordpressFeedUrl != '') {
				getCombinedStoriesList();
			} else {
				getLocalDocs();
			}

		} else if (canUseWordpressFeed && wordpressFeedUrl != '') {
			getCombinedStoriesList();
		}

		function getLocalDocs() {

			$('body').addClass('loading');

			var getLocalDocsPromise = $.get('/' + siteUrlAlias + '/news/json/all/false/0/999');

			getLocalDocsPromise.done(function (response) {
				var featured = [];
				var unFeatured = [];

				_.each(response.objects, function (story) {
					if (!story.published) {
						return;
					}
					story.customHeadContent = typeof story.customHeadContent == "string" && story.customHeadContent != "" ? JSON.parse(story.customHeadContent) : story.customHeadContent;
					if (story.customHeadContent && story.customHeadContent.featured) {
						featured.push(story);
					} else {
						unFeatured.push(story);
					}
				});

				var localStories = {
					featuredDocs: featured,
					activeDocs: unFeatured
				}

				$('#storiesIndex').empty().append(symphony.templates.storiesIndex({
					stories: localStories
				}));

				$('body').removeClass('loading');
			});

		}

		// GETTING the stories/posts set by CONDUCTOR
		function getWordpressDocs() {

			$('body').addClass('loading');

			if (sessionStorage && !_.isNull(sessionStorage.getItem('wpStories'))) {

				var localStories = JSON.parse(sessionStorage.getItem('wpStories'));
				$('#storiesIndex').empty().append(symphony.templates.storiesIndex({
					stories: localStories
				}));

				$('body').removeClass('loading');

			} else {

				var data = {
					per_page: 8
				};
				if (wpApiTagIds && wpApiTagIds.length > 0) {
					data['tags'] = wpApiTagIds;
				}
				var getWordpressDocsPromise = $.get(wpApiEndpoint + '/posts', data);

				getWordpressDocsPromise.done(function (data) {

					var localStories = {
						activeDocs: data
					};

					// Additional call to get the Featured Image for each post
					$.each(localStories.activeDocs, function (i, story) {
						story.title = story.title.rendered;
						story.description = story.excerpt.rendered;
						delete story.author;

						function finishStories() {
							localStories.activeDocs[i].headerImage = story.media ? story.media.source_url : null;

							// Store the results to sessionStorage for faster retrieval
							sessionStorage.setItem('wpStories', JSON.stringify(localStories));

							$('#storiesIndex').empty().append(symphony.templates.storiesIndex({
								stories: localStories
							}));

							$('body').removeClass('loading');
						}

						if (story.featured_media && story.featured_media != 0) {
							var featuredImage = $.get(wpApiEndpoint + '/media/' + story.featured_media);
							featuredImage.done(function (data) {
								localStories.activeDocs[i].media = data;

								finishStories();
							});
						} else {
							finishStories();
						}
					});

				});
			}
		}

		function getCombinedStoriesList() {
			symphony.wordpressFeed.getLocalStories(function () {
				symphony.wordpressFeed.getStories();
			});

			$(document).scroll(function () {
				if ($('.story-footerItem').last().offset().top - $('html').scrollTop() < $(window).height()) {
					if (!symphony.wordpressFeed.waitingForResponse) {
						symphony.wordpressFeed.getStories();
					}
				}
			});
		}
	};
})();

// WORDPRESSFEED = Added by Local Admin
symphony.wordpressFeed.getLocalStories = function (callback) {
	document.querySelector('.story-spinner').classList.add('loading-indicator');
	var getLocalDocsPromise = $.ajax({
		url: '/' + siteUrlAlias + '/news/json/all/false/0/999',
		dataType: 'json',
		type: 'GET',
		cache: false
	});

	getLocalDocsPromise
		.done(function (response) {
			var featured = [];
			var unFeatured = [];

			_.each(response.objects, function (story) {
				if (!story.published) {
					return;
				}
				story.customHeadContent = typeof story.customHeadContent == "string" && story.customHeadContent != "" ? JSON.parse(story.customHeadContent) : story.customHeadContent;
				if (story.customHeadContent && story.customHeadContent.featured) {
					featured.push(story);
				} else {
					unFeatured.push(story);
				}
			});

			symphony.wordpressFeed.localStories = {
				featuredDocs: featured,
				activeDocs: unFeatured
			};

			symphony.wordpressFeed.localStories.featuredDocs.sort(function (a, b) {
				if (a.customHeadContent && typeof a.customHeadContent.idx != "undefined" && b.customHeadContent && typeof b.customHeadContent.idx != "undefined") {
					return a.customHeadContent.idx < b.customHeadContent.idx ? -1 : 1;
				} else {
					return a.publishDate > b.publishDate ? -1 : 1;
				}
			});

			if (callback && typeof callback == "function") {
				callback();
			}
		})
		.fail(function () {
			if (symphony.wordpressFeed.localLoadTries < 10) {
				setTimeout(function () {
					symphony.wordpressFeed.getLocalStories();
				}, 300);
				symphony.wordpressFeed.localLoadTries++;
			}
		});

}

symphony.wordpressFeed.getStories = function () {
	if (symphony.wordpressFeed.pageNumber != null) {
		document.querySelector('.story-spinner').classList.add('loading-indicator');

		symphony.wordpressFeed.pageNumber++;
		wordpressFeedUrl = wordpressFeedUrl + (wordpressFeedUrl.indexOf('?') > -1 ? '&' : '?') + 'per_page=' + symphony.wordpressFeed.pageSize + '&page=' + symphony.wordpressFeed.pageNumber;
		var baseUrl = wordpressFeedUrl.split('/v2')[0] + '/v2';

		symphony.wordpressFeed.waitingForResponse = true;

		// GETTING WordPress Stories set by Local Admin
		$.get(wordpressFeedUrl, function (stories) {

			if (stories.length < symphony.wordpressFeed.pageSize) {
				// we've reached the end of the available stories
				symphony.wordpressFeed.pageNumber = null;
			}

			// Additional call to get the Featured Image for each post
			for (var i = 0; i < stories.length; i++) {
				var story = stories[i];

				story.title = story.title.rendered;
				story.description = story.excerpt.rendered;
				story.publishDate = story.date;
				delete story.author;

				// this is a USC Northern Division community news post
				// should have access to the news_image ACF
				if (story.news_image && story.news_image != '') {
					story.headerImage = story.news_image;
				} else if (story.featured_media && story.featured_media != 0) {
					$.ajax({
						url: baseUrl + '/media/' + story.featured_media,
						type: 'GET',
						async: false,
						success: function (data) {
							story.media = data;
							story.headerImage = story.media ? story.media.source_url : null;
						}
					});
				} else if (story.link.indexOf('community-news') > -1) {
					// this is a USC Northern Division community news post
					// find the parent post based on the slug
					$.ajax({
						url: baseUrl + '/posts?slug=' + story.slug,
						type: 'GET',
						async: false,
						success: function (posts) {
							if (posts.length > 0 && posts[0].featured_media && posts[0].featured_media != 0) {
								$.ajax({
									url: baseUrl + '/media/' + posts[0].featured_media,
									type: 'GET',
									async: false,
									success: function (data) {
										story.media = data;
										story.headerImage = story.media ? story.media.source_url : null;
									}
								});
							} else {
								story.headerImage = story.media ? story.media.source_url : null;
							}
						},
						fail: function () {
							story.headerImage = story.media ? story.media.source_url : null;
						}
					});
				} else {
					story.headerImage = story.media ? story.media.source_url : null;
				}
			}

			symphony.wordpressFeed.wordpressStories = symphony.wordpressFeed.wordpressStories.concat(stories);

			symphony.wordpressFeed.sortAndRender();
			symphony.wordpressFeed.waitingForResponse = false;
		});
	}
}

symphony.wordpressFeed.sortAndRender = function (dontRender) {

	// make working copies of lists
	var localStories = JSON.parse(JSON.stringify(symphony.wordpressFeed.localStories));
	var wordpressStories = JSON.parse(JSON.stringify(symphony.wordpressFeed.wordpressStories));

	var combinedActiveDocs = localStories.activeDocs.concat(wordpressStories);
	combinedActiveDocs.sort(function (a, b) {
		return a.publishDate > b.publishDate ? -1 : 1;
	});

	// splice combined list (set of 12)
	var newCombinedActiveDocsSet = combinedActiveDocs.splice(0, 12);

	// remove combined items from local & wp story lists
	localStories.activeDocs = $.grep(localStories.activeDocs, function (ls) {
		return newCombinedActiveDocsSet.map(function (x) {
			return x.id
		}).indexOf(ls.id) == -1;
	});
	wordpressStories = $.grep(wordpressStories, function (ls) {
		return newCombinedActiveDocsSet.map(function (x) {
			return x.id
		}).indexOf(ls.id) == -1;
	});

	// if WP list is empty and pageNumber != null, load some more and try again
	if (wordpressStories.length == 0 && symphony.wordpressFeed.pageNumber != null) {
		symphony.wordpressFeed.getStories();
		return;
	}

	// all the WP stories have been loaded,
	// go ahead and render all the remaining stories
	if (symphony.wordpressFeed.pageNumber == null) {
		newCombinedActiveDocsSet = newCombinedActiveDocsSet.concat(combinedActiveDocs);

		// remove combined items (all) from local & wp story lists
		localStories.activeDocs = [];
		wordpressStories = [];
	}

	// set all the lists to the new values	
	symphony.wordpressFeed.localStories = localStories;
	symphony.wordpressFeed.wordpressStories = wordpressStories;
	symphony.wordpressFeed.combinedActiveDocs = symphony.wordpressFeed.combinedActiveDocs.concat(newCombinedActiveDocsSet);

	if (!dontRender) {
		$('#storiesIndex').html(symphony.templates.storiesIndex({
			stories: {
				featuredDocs: symphony.wordpressFeed.localStories.featuredDocs,
				activeDocs: symphony.wordpressFeed.combinedActiveDocs
			}
		}));

		// remove 'read more' button from wordpress excerpt
		$('#storiesIndex .story-description a.button').remove();
		$('#storiesIndex .story-description a.btn').remove();
		document.querySelector('.story-spinner').classList.remove('loading-indicator');
	}
}
